import Settings from 'source/lib/settings_model';
import loadScript from './script';

function loadCommonMenu() {
    const settings = Settings.get('Request.CommonMenuLoader');

    if (!settings) {
        return Promise.resolve(false);
    }
    let attributes = [];

    if (settings.Parameters) {
        // Will be fixed in WGNI-3526
        attributes = settings.Parameters
            .split(/\s/).filter(parametr => parametr.length > 0)
            .map(parametr => {
                const results = /([^=]+)=?(.*)/g.exec(parametr);
                if (results.length >= 3) {
                    return [results[1].replace(/"/gi, ''), results[2].replace(/"/gi, '')];
                }
                return [];
            });
    }
    attributes.push(['id', 'common_menu_loader']);
    attributes.push(['data-ot-ignore', 'true']);
    const promises = [loadScript(settings.Url, {
        noCatch: true,
        attributes,
    })];

    if (settings.ExtraScriptUrl) {
        const staticUrl = Settings.get('App.StaticUrl', '');
        promises.push(loadScript(`${staticUrl}${settings.ExtraScriptUrl}`, {
            noCatch: true,
            attributes: [
                ['data-ot-ignore', 'true'],
            ],
        }));
    }
    return Promise.all(promises);
}

export default loadCommonMenu;
